var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Download 1  White") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Download-1--White"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.303781703,
    transform: "translate(18.750000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0 0 31.25 0 31.25 31.25 0 31.25"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.8786765,19.6384804 L31.3419118,19.6384804 L31.3419118,8.33333333 L20.0367647,8.33333333 L20.0367647,19.6384804 L12.5,19.6384804 L25.6893382,32.8278186 L38.8786765,19.6384804 Z M12.5,36.596201 L12.5,40.3645833 L38.8786765,40.3645833 L38.8786765,36.596201 L12.5,36.596201 Z",
    id: "Shape-Copy",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadArrowWhite);
export default __webpack_public_path__ + "static/media/download-arrow-white.71fcc615e6102d4bed161518b8cb143a.svg";
export { ForwardRef as ReactComponent };